import { useEffect, useState } from "react";

// Bumps a counter when the tab regains focus and every `intervalMs`, so dashboards re-pull fresh data.
export default function useRefreshTick(intervalMs = 60000) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const bump = () => { if (document.visibilityState === "visible") setTick(t => t + 1); };
    const id = setInterval(bump, intervalMs);
    document.addEventListener("visibilitychange", bump);
    window.addEventListener("focus", bump);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", bump); window.removeEventListener("focus", bump); };
  }, [intervalMs]);
  return tick;
}
